import { WarningPopup } from '@/pages/roster/staffPicker/warningsIndicator/WarningPopup';
import { getSeverityType } from '@/services/warnings/severityHelper';
import { FC } from 'react';
import { WarningsList } from './WarningsList';
import { EmployeeForShiftItem } from '@/types/employeeForShift.types';
import { useWarningsForShift } from '../../providers/RosterWarningsService';
import { RosterPickerIcon } from '../RosterPickerIcon';
import { TimeshiftAvatar } from '@/components/shared/TimeshiftAvatar';

interface Props {
  shiftId: string;
  selectedUser?: EmployeeForShiftItem;
}

export const WarningsIndicator: FC<Props> = ({ shiftId, selectedUser }) => {
  const warnings = useWarningsForShift(shiftId);
  const severity = getSeverityType(warnings);

  if (!selectedUser) {
    return <RosterPickerIcon name={''} />;
  } else if (warnings.length === 0) {
    return <TimeshiftAvatar name={selectedUser.name} src={selectedUser.details?.avatarUrl} size={30}></TimeshiftAvatar>;
  } else {
    return <WarningPopup severity={severity} parentContainerId={'roster-table-wrapper'}>
      <WarningsList warnings={warnings} />
    </WarningPopup>;
  }
};
